<modal #modal [css-class]="'age-restriction'">
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalLabel">Aldersgrænse på 18 år</h5>
		<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCloseClick()">
		
		</button>
	</div>
	<div class="modal-body">
		<p>De informationer, du har indtastet, lever ikke op til kravene for deltagelse i Klasselotteriets aktiviteter.</p>
		<p>Du skal være fyldt 18 år for at deltage.</p>
	</div>
	<div class="modal-footer">
		<p>Er dette ikke korrekt, så kontakt Kundeservice via vores chat, <a href="mailto:kundeservice@klasselotteriet.dk">mail</a> eller telefon: 3342 0900, mandag-fredag 9.00-18.00.</p>
	</div>
</modal>
